import Keycloak from 'keycloak-js';

const keycloakConfig = {
  url: process.env.REACT_APP_KEYCLOAK_URL || 'http://localhost:8080',
  realm: process.env.REACT_APP_KEYCLOAK_REALM || 'timbertrack',
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || 'timbertrack-web',
};

const keycloak = new Keycloak(keycloakConfig);

// Singleton getter function for use in interceptors
export const getKeycloakInstance = (): Keycloak | null => {
  return keycloak;
};

export default keycloak;
